import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import UserGroupsTable, {
  PaginationModelChangeProps,
} from '../../components/UserGroups/UserGroupsTable/UserGroupsTable';
import getColumns from '../../components/UserGroups/UserGroupsTable/columns';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/rootReducer';
import { userGroupsActions } from '../../redux/userGroups/userGroupsSlice';

const UserGroups = () => {
  const dispatch = useDispatch();
  const { userGroups, totalUserGroupsCount, fetchUsergroupsLoading } = useAppSelector(
    (state: RootState) => state.userGroups
  );

  const [pageSize, setPageSize] = useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const skip = page * pageSize;

  const handlePaginatiChangeActive = (event: PaginationModelChangeProps) => {
    setPageSize(event.pageSize);
    setPage(event.page);
  };

  const fetchUserGroups = () => {
    const payload = {
      searchQuery: searchTerm,
      skip,
      take: pageSize,
      organizationId: 'decb4748-9dba-4672-b0c2-88aad43fc307',
    };
    dispatch(userGroupsActions.fetchAllUserGroups(payload));
  };

  useEffect(() => {
    fetchUserGroups();
  }, [pageSize, page]);

  const debouncedFetchUserGroups = useCallback(
    debounce(({ filterText }: { filterText: string }) => {
      const payload = {
        searchQuery: filterText,
        skip,
        take: pageSize,
        organizationId: 'decb4748-9dba-4672-b0c2-88aad43fc307',
      };
      dispatch(userGroupsActions.fetchAllUserGroups(payload));
    }, 1000),
    [dispatch, skip, pageSize]
  );

  const handleChangeSearchTerm = (newValue: string) => {
    setSearchTerm(newValue);
    debouncedFetchUserGroups({ filterText: newValue });
  };

  useEffect(
    () => () => {
      debouncedFetchUserGroups.cancel();
    },
    [debouncedFetchUserGroups]
  );

  return (
    <CoachPageLayout>
      <UserGroupsTable
        handleOnPaginationModelChange={handlePaginatiChangeActive}
        rows={!fetchUsergroupsLoading ? userGroups : []}
        rowCount={totalUserGroupsCount}
        loading={fetchUsergroupsLoading}
        columns={getColumns()}
        handleOnChangeSearchTerm={handleChangeSearchTerm}
        searchTerm={searchTerm}
        pageSize={pageSize}
        page={page}
      />
    </CoachPageLayout>
  );
};
export default UserGroups;
